export const TID = {
  // Auth
  langSwitcher: "lang-switcher",
  phoneInput: "login-phone-input",
  sendOtpBtn: "login-send-otp-btn",
  otpInput: "login-otp-input",
  nameInput: "login-name-input",
  businessInput: "login-business-input",
  verifyOtpBtn: "login-verify-otp-btn",
  changePhoneBtn: "login-change-phone-btn",

  // Nav
  navHome: "nav-home",
  navOrders: "nav-orders",
  navSettings: "nav-settings",
  logoutBtn: "logout-btn",

  // Home
  newDesignBtn: "home-new-design-btn",
  statTotal: "home-stat-total",
  statMonth: "home-stat-month",
  statValue: "home-stat-value",
  statShared: "home-stat-shared",
  recentList: "home-recent-list",
  recentItem: "home-recent-item",

  // New design
  fileInput: "upload-file-input",
  captureBtn: "upload-capture-btn",
  galleryBtn: "upload-gallery-btn",
  imagePreview: "upload-image-preview",
  analyzeBtn: "ai-analyze-btn",
  aiResult: "ai-analysis-result",
  designNameInput: "form-design-name",
  garmentSelect: "form-garment-select",
  brandSelect: "form-brand-select",
  fabricInput: "form-fabric-input",
  stitchCountInput: "form-stitch-count",
  machineTimeInput: "form-machine-time",
  colorsInput: "form-thread-colors",
  zariSwitch: "form-zari-switch",
  sequinSwitch: "form-sequin-switch",
  formatSelect: "form-output-format",
  generateBtn: "form-generate-btn",

  // Processing
  processingStage: "processing-stage",

  // Results
  resultsStitchCount: "results-stitch-count",
  resultsMachineTime: "results-machine-time",
  resultsColors: "results-colors",
  resultsFormat: "results-format",
  downloadStitchBtn: "results-download-stitch",
  materialCost: "results-material-cost",
  machineCost: "results-machine-cost",
  laborCost: "results-labor-cost",
  suggestedPrice: "results-suggested-price",
  finalPriceInput: "results-final-price",
  savePriceBtn: "results-save-price",
  deliveryDate: "results-delivery-date",
  shareBtn: "results-share-btn",
  downloadPdfBtn: "results-download-pdf",
  waShareBtn: "results-whatsapp-share",

  // Orders
  ordersSearch: "orders-search",
  ordersItem: "orders-item",

  // Settings
  settingsMachineRate: "settings-machine-rate",
  settingsLaborRate: "settings-labor-rate",
  settingsMargin: "settings-margin",
  settingsThread: "settings-thread",
  settingsZari: "settings-zari",
  settingsSequin: "settings-sequin",
  settingsSave: "settings-save-btn",
};
